import { Text } from 'components';
import { FontSize } from 'commons';

interface Props {
  score: number;
}

export function ScoreDescription({ score }: Props) {
  switch (score) {
    case 4:
      return (
        <Text size={FontSize.font16} className="info-text">
          No próximo nível, você recebe pedidos estaduais e será prioridade no
          direcionamento dos pedidos.
        </Text>
      );

    case 5:
      return (
        <Text size={FontSize.font16} className="info-text">
          Sua loja está habilitada para entrega estadual e tem prioridade no
          direcionamento dos pedidos.
        </Text>
      );

    case 6:
      return (
        <Text size={FontSize.font16} className="info-text">
          Sua loja está temporariamente com prioridade no direcionamento dos
          pedidos.
        </Text>
      );

    default:
      return (
        <Text size={FontSize.font16} className="info-text">
          Atenda mais pedidos para subir de nível e ser prioridade no
          direcionamento de pedidos.
        </Text>
      );
  }
}
